// extracted by mini-css-extract-plugin
export default {"googleButton":"ReactModal_googleButton__NXjEU","googleIconDiv":"ReactModal_googleIconDiv__wqKsz","closeIcon":"ReactModal_closeIcon__BEM7c"};